import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { logout } from "../actions/authenActions";

const baseURL = process.env.REACT_APP_API_URL || "http://localhost:8000";

/* Fetch categories */
export const fetchRuleCategories = createAsyncThunk(
  "rulesInReview/fetchRuleCategories",
  async ({ access_token }, { dispatch, rejectWithValue }) => {
    try {
      const res = await axios.get(
        `${baseURL}/emis_pathology/api/rule_categories/`,
        { headers: { Authorization: `Bearer ${access_token}` } },
      );
      return res.data || [];
    } catch (error) {
      if (error.response?.status === 403) dispatch(logout());
      return rejectWithValue(error.response?.data);
    }
  },
);

/* Search rules */
export const searchRules = createAsyncThunk(
  "rulesInReview/searchRules",
  async (
    { category, license_email, access_token },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/search_rule_inreview/`,
        { category, license_email },
        { headers: { Authorization: `Bearer ${access_token}` } },
      );
      return res.data || [];
    } catch (error) {
      if (error.response?.status === 403) dispatch(logout());
      return rejectWithValue(error.response?.data);
    }
  },
);

/* Bulk update */
export const bulkUpdateRules = createAsyncThunk(
  "rulesInReview/bulkUpdateRules",
  async (
    { category, license_email, inreview, access_token },
    { dispatch, rejectWithValue },
  ) => {
    try {
      const res = await axios.post(
        `${baseURL}/emis_pathology/api/bulk_update_rule_inreview/`,
        { category, license_email, inreview },
        { headers: { Authorization: `Bearer ${access_token}` } },
      );
      return res.data;
    } catch (error) {
      if (error.response?.status === 403) dispatch(logout());
      return rejectWithValue(error.response?.data);
    }
  },
);

const rulesInReviewSlice = createSlice({
  name: "rulesInReview",
  initialState: {
    categories: [],
    rules: [],
    loadingCategories: false,
    loadingRules: false,
    updating: false,
  },

  reducers: {
    clearRules(state) {
      state.rules = [];
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(fetchRuleCategories.pending, (state) => {
        state.loadingCategories = true;
      })
      .addCase(fetchRuleCategories.fulfilled, (state, action) => {
        state.loadingCategories = false;
        state.categories = action.payload;
      })
      .addCase(fetchRuleCategories.rejected, (state) => {
        state.loadingCategories = false;
      })

      .addCase(searchRules.pending, (state) => {
        state.loadingRules = true;
      })
      .addCase(searchRules.fulfilled, (state, action) => {
        state.loadingRules = false;

        state.rules = action.payload.map((rule, idx) => ({
          id: rule._id?.$oid || idx,
          organization_name: rule.organization_name,
          license_email: rule.license_email,
          category: rule.category,
          inreview: rule.inreview || "Disabled",
        }));
      })
      .addCase(searchRules.rejected, (state) => {
        state.loadingRules = false;
      })

      .addCase(bulkUpdateRules.pending, (state) => {
        state.updating = true;
      })
      .addCase(bulkUpdateRules.fulfilled, (state) => {
        state.updating = false;
      })
      .addCase(bulkUpdateRules.rejected, (state) => {
        state.updating = false;
      });
  },
});

export const { clearRules } = rulesInReviewSlice.actions;
export default rulesInReviewSlice.reducer;
